import { ImporterDateRange } from '~common/google-api/types'

export type DateRange = {
    from: Date | undefined
    to?: Date | undefined
}

// TODO-audit: This seems like an unnecessary level of indirection. Why not just use one of either ImporterDateRange or DateRange?
export function convertImporterDateRange(
    importerRange: ImporterDateRange,
): DateRange {
    if (
        'fromYear' in importerRange &&
        importerRange.fromYear !== undefined &&
        'fromMonth' in importerRange &&
        importerRange.fromMonth !== undefined &&
        'toYear' in importerRange &&
        importerRange.toYear !== undefined &&
        'toMonth' in importerRange &&
        importerRange.toMonth !== undefined &&
        'fromDay' in importerRange &&
        importerRange.fromDay !== undefined &&
        'toDay' in importerRange &&
        importerRange.toDay !== undefined
    ) {
        // Convert month range to date range
        const from = new Date(
            Date.UTC(importerRange.fromYear, importerRange.fromMonth - 1, 1),
        )
        const to = new Date(
            Date.UTC(
                importerRange.toYear,
                importerRange.toMonth - 1,
                importerRange.toDay,
            ),
        )

        return {
            from,
            to,
        }
    }

    // TODO-audit: Is this a good idea? Why not throw an error?
    // Fallback for invalid/empty range
    return {
        from: undefined,
        to: undefined,
    }
}
